import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledPreferredPaymentHeader = styled.div`
  .loader {
    height: ${toRem(144)};
  }

  .t-overline-normal {
    color: ${color.neutral40};
  }

  .item-value {
    font-weight: ${font.fontWeightMedium};
    font-size: ${font.fontL};
  }
`;
